import { useEffect, useState } from 'react';

/**
 * Tracks whether the viewport is narrower than `breakpoint` (px). Installs
 * a single `resize` listener and returns the latest value as a boolean.
 *
 * Defaults to `768` to match the app's phone/tablet breakpoint.
 */
const useIsMobile = (breakpoint = 768) => {
  const [isMobile, setIsMobile] = useState(
    typeof window !== 'undefined' && window.innerWidth < breakpoint
  );

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < breakpoint);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [breakpoint]);

  return isMobile;
};

export default useIsMobile;
